module.exports = __webpack_public_path__ + "img/evolution5.f17274ae.png";